import React from "react";

const PoolContext = React.createContext();

export default PoolContext;